module.exports = __webpack_public_path__ + "img/relaxation.657e1254.jpg";